// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Term_wrap_fNNX5","section":"Term_section_1bz1c","heading1":"Term_heading1_24A9T"};